import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-park_bth_phone",
  "use": "icon-park_bth_phone-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-park_bth_phone\"><clipPath id=\"icon-park_bth_phone_a\"><path d=\"m0 0h24v24h-24z\" /></clipPath><g clip-path=\"url(#icon-park_bth_phone_a)\" fill=\"#1a1a1a\"><path d=\"m12 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75c2.89 0 5.25-2.36 5.25-5.25v-8c0-2.9-2.36-5.25-5.25-5.25s-5.25 2.35-5.25 5.25v8c0 .41-.34.75-.75.75h-1c-1.52 0-2.75-1.23-2.75-2.75v-4c0-1.52 1.23-2.75 2.75-2.75h.29c.37-3.37 3.24-6 6.71-6 3.72 0 6.75 3.03 6.75 6.75v8c0 3.72-3.03 6.75-6.75 6.75zm-7-14c-.69 0-1.25.56-1.25 1.25v4c0 .69.56 1.25 1.25 1.25h.25v-6.5z\" /><path d=\"m19 16.75h-1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c.69 0 1.25-.56 1.25-1.25v-4c0-.69-.56-1.25-1.25-1.25h-1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c1.52 0 2.75 1.23 2.75 2.75v4c0 1.52-1.23 2.75-2.75 2.75z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/park_bth_phone.svg
// module id = o9wC
// module chunks = 87